import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import SiteCustomerSupportComponent from "./site-customer-support.component";
import { humanCloneVideoUrl } from "./site-human-clone.component";
import SiteSocialNetworkComponent from "./site-social-network.component";

const SiteHumanClonePage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section id="human-clone">
      <Container
        fluid={"xl"}
        className="max-w-screen-md d-flex flex-column tw-py-10 align-items-center"
      >
        <Row className="tw-w-full">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <h5 className="font-sofiaSans tw-font-extrabold md:tw-text-2xl tw-text-lg tw-text-blue-800">
                {t("SiteHumanClone/title")}
              </h5>
              <h1 className="font-sofiaSans tw-font-extrabold md:tw-text-5xl tw-text-2xl">
                {t("SiteHumanClone/t-01")}
              </h1>
            </div>
            <div className="ratio ratio-16x9 tw-mt-6">
              <iframe
                allow="camera; microphone"
                src={humanCloneVideoUrl}
                title="YouTube video"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
        </Row>
        <Row className="tw-w-full tw-mt-8">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <h5 className="font-sofiaSans tw-font-extrabold md:tw-text-2xl tw-text-lg">
                {t("SiteHumanClone/t-02")}
              </h5>
              <p className="max-w-screen-sm font-sofiaSans tw-text-sm">
                {t("SiteHumanClone/text-02")}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="tw-w-full tw-mt-1">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <h5 className="font-sofiaSans tw-font-extrabold tw-text-lg">
                {t("SiteHumanClone/t-03")}
              </h5>
              <p className="max-w-screen-sm font-sofiaSans tw-text-sm">
                {t("SiteHumanClone/text-03")}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="tw-w-full tw-mt-1">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <h5 className="font-sofiaSans tw-font-extrabold tw-text-lg">
                {t("SiteHumanClone/t-04")}
              </h5>
              <p className="max-w-screen-sm font-sofiaSans tw-text-sm">
                {t("SiteHumanClone/text-04")}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="tw-w-full tw-mt-1">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <h5 className="font-sofiaSans tw-font-extrabold tw-text-lg">
                {t("SiteHumanClone/t-05")}
              </h5>
              <p className="max-w-screen-sm font-sofiaSans tw-text-sm">
                {t("SiteHumanClone/text-05")}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="tw-w-full tw-mt-1">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <h5 className="font-sofiaSans tw-font-extrabold tw-text-lg">
                {t("SiteHumanClone/t-06")}
              </h5>
              <p className="max-w-screen-sm font-sofiaSans tw-text-sm">
                {t("SiteHumanClone/text-06")}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="tw-w-full tw-mt-1">
          <Col className="d-flex flex-column justify-content-center text-center align-items-center">
            <div className="tw-w-full tw-text-start">
              <p className="max-w-screen-sm font-sofiaSans tw-text-sm tw-text-zinc-500">
                {t("SiteHumanClone/text-07")}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <SiteCustomerSupportComponent />
      <SiteSocialNetworkComponent />
    </section>
  );
};

export default SiteHumanClonePage;
